import { Grid } from '@mui/material';

import { US_STATE_OPTIONS } from '../../../../../../../constants';
import { FormAutocompleteField, FormTextField } from '../../../../../../common';

import type { PolicyholderAddressFieldsProps } from './types';

export default function PolicyholderAddressFields({
  formik,
  disabled,
  saveFieldOnBlur,
  handleAddressFieldChange,
  saveAddressFieldOnChange,
}: PolicyholderAddressFieldsProps) {
  return (
    <>
      <Grid item xs={12} md={6}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          label="Policyholder street address line one"
          name="policyholder_street_address_line_one"
          onBlur={saveFieldOnBlur}
          onChange={handleAddressFieldChange}
          required
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          label="Policyholder address line two (Apartment/unit)"
          name="policyholder_street_address_line_two"
          onBlur={saveFieldOnBlur}
          onChange={handleAddressFieldChange}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          label="Policyholder city"
          name="policyholder_street_address_city"
          onBlur={saveFieldOnBlur}
          onChange={handleAddressFieldChange}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <FormAutocompleteField
          disabled={disabled}
          formik={formik}
          label="Policyholder state"
          name="policyholder_street_address_state"
          onChange={saveAddressFieldOnChange}
          options={US_STATE_OPTIONS}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          label="Policyholder zip code"
          name="policyholder_street_address_zip"
          onBlur={saveFieldOnBlur}
          onChange={handleAddressFieldChange}
          required
        />
      </Grid>
    </>
  );
}
